import useSetupApp from 'apps/hooks/useSetupApp'

export default function AppConfig () {
  useSetupApp()

  return null
}
